import axios from "axios";

import Config from "src/config";

const v2_actionCampanhaDetalhes = (id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/marketing/campanhas-rastreamento/${id}/detalhes`

    });
};
export default v2_actionCampanhaDetalhes;
